// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_2787e5dfdf--tooltip--M1G81","arrow_tooltip":"_2787e5dfdf--arrow_tooltip--xm3aH","arrow":"_2787e5dfdf--arrow--QDoVo"};